import { z } from "zod";
import { Timestamp } from "firebase/firestore";

/**
 * Zod schema for validating Firebase Timestamp objects
 * Used across all Firestore collection schemas that have timestamp fields
 *
 * Nullable because serverTimestamp() resolves to null in the local
 * onSnapshot callback before the server confirms the write.
 */
export const FirestoreTimestampSchema = z.instanceof(Timestamp).nullable();

/**
 * Non-null Firestore timestamp fields. The drift checker understands z.date()
 * as a timestamp, while the runtime parser still accepts Firestore Timestamp.
 */
export const RequiredFirestoreTimestampSchema = z
  .date()
  .or(z.instanceof(Timestamp));
